interface MarkerProps {
  text: string;
  onClick?: () => void;
  lat: any;
  lng: any;
}

const Marker: React.FC<MarkerProps> = ({ text, onClick }) => {
  return (
    <div className="h-2 w-2 relative">
      <div className=" absolute -top-[47px] -left-[18px]">
        <svg
          width="37"
          height="57"
          viewBox="0 0 37 57"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_34122_6986)">
            <rect
              width="2"
              height="20"
              transform="translate(17.8535 28.6519)"
              fill="#333333"
            />
            <rect
              x="6.85352"
              y="2.65195"
              width="24"
              height="24"
              rx="12"
              fill="#F60000"
            />
            <rect
              x="6.85352"
              y="2.65195"
              width="24"
              height="24"
              rx="12"
              stroke="white"
              strokeWidth="4"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_34122_6986"
              x="0.853516"
              y="0.651947"
              width="36"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_34122_6986"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_34122_6986"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default Marker;
